var render = function render(){var _vm=this,_c=_vm._self._c;return _c('r-admin-layout',{staticClass:"a-create-user"},[_c('template',{slot:"title"},[_c('b-icon',{attrs:{"icon":"person-fill"}}),_vm._v("Add User")],1),_c('r-admin-card',{attrs:{"title":"User Information"}},[_c('r-create-user-form')],1)],2)
}
var staticRenderFns = []

export { render, staticRenderFns }